/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Spaces_Spreadsheet_Page_OfInputs */



/**
* | output |
* | --- |
* | "Page {current} of {total}" |
*
* @param {Spaces_Spreadsheet_Page_OfInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_spreadsheet_page_of = /** @type {((inputs: Spaces_Spreadsheet_Page_OfInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Spreadsheet_Page_OfInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Seite ${i?.current} von ${i?.total}`)
	return /** @type {LocalizedString} */ (`Page ${i?.current} of ${i?.total}`)
});